import styled from 'styled-components';
import media from '../../../../styles/media.style';
import { BLACK, WHITE, BG_GRAY } from '../../../../styles/variables.style';

export const Spacer = styled.div`
  display: block;
  margin-top: 100px;
`;

export const ItemWrapper = styled.div`
  display: block;
  padding: 30px 20px;

  ${media.tabletP`
    padding: 40px 60px 60px 60px;
  `};
`;

export const ItemContainer = styled.div`
  display: block;
  padding: 0;

  ${media.tabletP`
    display: table;
    table-layout: fixed;
    width: 100%;
  `};
`;

export const ItemContainerLeft = styled.div`
  display: block;
  padding: 0;
  border-bottom: solid 1px #ccc;

  ${media.tabletP`
    display: table-cell;
    padding: 0 60px 0 0;
    width: 50%;
    box-sizing: border-box;
    border-bottom: none;
    border-right: solid 1px #ccc;
  `};
`;

export const ItemContainerRight = styled.div`
  display: block;
  padding: 40px 0 0 0;

  ${media.tabletP`
    display: table-cell;
    padding: 0 0 0 60px;
    width: 50%;
    box-sizing: border-box;
  `};
`;

export const ItemContainerFull = styled.div`
  display: block;
  padding: 40px 0 0 0;

  ${media.tabletP`
    display: table-cell;
    padding: 80px 0 0 0;
    width: 100%;
    box-sizing: border-box;
  `};
`;

export const Item = styled.div`
  height: auto;
  width: 100%;
`;

export const ItemTitle = styled.h3`
  font-size: 17px;
  line-height: 18px;
  color: ${BLACK};
  margin-bottom: 24px;
  text-align: center;

  ${media.tabletP`
    font-size: 24px;
    line-height: 26px;
    margin-bottom: 20px;
  `};
`;

export const ItemStatusTitle = styled.div`
  display: block;
  margin: 0 0 10px 0;
  width: 100%;
  color: ${BLACK};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
`;

export const ItemStatusContents = styled.div`
  font-size: 15px;
  color: ${BLACK};
  margin-bottom: 20px;
  text-align: center;

  ${media.tabletP`
    font-size: 20px;
  `};

  b {
    font-weight: bold;
  }

  &.withDamageIndicator {
    margin-bottom: 20px;
  }

  &.withPicture {
    margin-bottom: 40px;
  }
`;

export const ItemImage = styled.div`
  color: ${BLACK};
  display: flex;
  align-items: center;
  width: 100%;
  height: 196px;

  .chart {
    position: relative;
    text-align: center;
    width: 196px;
    height: 196px;
    margin: 0 auto;
    border-radius: 50%;
    overflow: hidden;
    background-color: ${WHITE};

    .text {
      width: 100%;
      position: absolute;
      z-index: 2;
      top: 47px;
      font-size: 14px;
    }

    .number {
      width: 100%;
      position: absolute;
      z-index: 2;
      top: 50%;
      transform: translateY(-35%);
      font-size: 49px;
    }

    .image {
      width: 100%;
      position: absolute;
    }

    :after {
      position: absolute;
      top: 12px;
      left: 12px;
      display: block;
      content: ' ';
      border-radius: 50%;
      background-color: ${WHITE};
      width: 172px;
      height: 172px;
      background-color: #edf1f5;
    }

    * {
      box-sizing: content-box;
    }

    .slice {
      position: absolute;
      width: 98px;
      height: 196px;
      z-index: 3;
      clip: ${({ damageLevel }) =>
        360 * damageLevel > 180 ? 'rect(auto, auto, auto, auto)' : 'rect(0px, 98px, 196px, 0px)'};
    }
    .bar {
      position: absolute;
      border: 12px solid #9fabc8;
      width: 172px;
      height: 172px;
      clip: rect(0px, 98px, 196px, 0px);
      border-radius: 50%;
    }
    .slice2 {
      left: 98px;
      position: absolute;
      width: 98px;
      height: 196px;
      z-index: 3;
      clip: ${({ damageLevel }) =>
        360 * damageLevel > 180 ? 'rect(auto, auto, auto, auto)' : 'rect(0px, 98px, 196px, 0px)'};
    }
    .bar2 {
      left: -98px;
      position: absolute;
      border: 12px solid #9fabc8;
      width: 172px;
      height: 172px;
      clip: rect(0px, 98px, 196px, 0px);
      border-radius: 50%;
    }
    &.level0 {
      .bar {
        transform: rotate(180deg);
      }
      .bar2 {
        transform: rotate(0deg);
      }
    }
    &.level1 {
      .bar {
        transform: rotate(180deg);
      }
      .bar2 {
        transform: rotate(90deg);
      }
    }
    &.level2 {
      .bar {
        transform: rotate(180deg);
      }
      .bar2 {
        transform: rotate(180deg);
      }
    }
    &.level3 {
      .bar {
        transform: rotate(270deg);
      }
      .bar2 {
        transform: rotate(180deg);
      }
    }
    &.level4 {
      .bar {
        transform: rotate(360deg);
      }
      .bar2 {
        transform: rotate(180deg);
      }
    }
  }
`;

export const PictureWrapper = styled.div`
  width: 190px;
  height: 140px;
  margin: 0 auto 40px auto;

  ${media.tabletP`
    width: 180px;
    height: 135px;
    margin-bottom: 50px;
  `};
`;

export const Picture = styled.img`
  max-width: 100%;
`;

export const ItemArrow = styled.div`
  margin: 40px auto;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 20px 30px 0 30px;
  border-color: #b7cce5 transparent transparent transparent;

  ${media.tabletP`
    margin: 30px auto;
  `};
`;

export const Hr = styled.div`
  background-color: ${BG_GRAY.COMMON_4};
  height: 3px;
  width: 50px;
  margin: 15px auto 20px calc(50% - 25px);

  ${media.tabletP`
    margin: 26px auto 40px calc(50% - 25px);
  `};
`;

export const ItemNavigation = styled.nav`
  display: block;
  height: auto;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
`;

export const ItemNavigationTitle = styled.h1`
  font-size: 16px;
  line-height: 18px;
  color: ${BLACK};
  margin-bottom: 24px;

  ${media.tabletP`
    font-size: 24px;
    line-height: 26px;
    padding: 0;
    margin-bottom: 30px;
  `};
`;

export const ItemNavigationList = styled.ul`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  > li:nth-child(1) {
    padding-left: 0;
  }
  > li:nth-child(2) {
    padding-right: 0;
  }
  > li:nth-child(3) {
    padding-top: 40px;
  }
`;

export const ItemNavigationListItem = styled.li`
  padding: 10px;
  flex-basis: 50%;

  ${media.tabletP`
    padding: 15px !important;
    flex-basis: 33.3%;
  `};
`;

export const ItemNavigationButton = styled.a`
  display: block;
  width: 100%;
  line-height: 47px;
  color: #fff;
  font-size: 13px;
  text-align: center;
  border: none;
  background-color: #959b9f;
  img {
    display: block;
    width: 100%;
    height: auto;
  }

  ${media.tabletP`
    font-size: 16px;
    line-height: 50px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/TopPage/TopPage.style.js